export const translationLivechat_sv_part2 = {
  livechatFailedTransferSession: "Det gick inte att överföra livechat-sessionen.",
  livechatFailedCloseSession: "Det gick inte att stänga livechat-sessionen.",
  livechatFailedLoadSessions: "Det gick inte att ladda livechat-sessioner.",
  livechatFailedLoadSession: "Det gick inte att ladda livechat-sessionen.",
  livechatSessionUnavailableTitle: "Konversationen är inte längre tillgänglig",
  livechatSessionUnavailableDescription:
    "Den kan ha tagits bort, till exempel eftersom besökaren raderade sina uppgifter.",
  livechatFailedLoadTranscript: "Det gick inte att ladda livechat-utskriften.",
  livechatFailedLoadAiContext: "Det gick inte att ladda AI-kontext.",
  livechatFailedLoadAgents: "Det gick inte att ladda livechat-agenter.",
  livechatFailedLoadSettings: "Det gick inte att ladda livechat-inställningar.",
  livechatFailedSaveSettings: "Det gick inte att spara livechat-inställningar.",
  livechatCloseReasonDashboard: "Stängd från instrumentpanelens livechat-arbetsyta",
  livechatConversationSelectTitle: "Välj en livechat-session",
  livechatConversationSelectHint:
    "Välj en väntande, aktiv eller stängd session för att se hela konversationen och supportkontexten.",
  livechatLiveSession: "Live-session",
  livechatJoinSession: "Gå med i session",
  livechatJoining: "Går med...",
  livechatTakeoverProviderControl: "Ta över",
  livechatTakingOverProviderControl: "Tar över...",
  livechatTransferSession: "Överför",
  livechatTransferredToYou: "Överförd till dig",
  livechatTransferReceivedTitle: "Konversation överförd till dig",
  livechatTransferReceivedOpen: "Öppna konversation",
  livechatTransferReceivedOsBody: "En konversation har överförts till dig.",
  livechatTransferReceivedOsBodyFrom: "{agent} har överfört en konversation till dig.",
  livechatSessionTakenOverTitle: "Konversation övertagen",
  livechatSessionTakenOverOsBody: "En annan agent tog över konversationen från dig.",
  livechatSessionTakenOverOsBodyFrom: "{agent} tog över konversationen från dig.",
  livechatTransferTargetLabel: "Överför till",
  livechatTransferNoTargets: "Inga andra agenter är tillgängliga för den här chatboten.",
  livechatTransferConfirm: "Överför session",
  livechatTransferring: "Överför...",
  livechatTakeoverSession: "Ta över session",
  livechatTakingOverSession: "Tar över...",
  livechatCloseSession: "Stäng session",
  livechatSessionClosed: "Session stängd",
  livechatClosing: "Stänger...",
  livechatSessionContext: "Sessionskontext",
  livechatSessionMetadata: "Metadata · Overifierat",
  livechatSessionMetadataHint:
    "Tillhandahållet av besökarens webbläsare. Dessa värden är inte verifierade.",
  livechatMetadataShowAll: "Visa alla ({count})",
  livechatMetadataHide: "Dölj",
  livechatSessionContextEnvironment: "Miljö",
  livechatSessionContextVisitorSession: "Besökarsession",
  livechatSessionContextLivechat: "Livechat",
  livechatSessionContextRequested: "Begärd",
  livechatSessionContextAgentJoined: "Agent anslöt",
  livechatSessionContextClosed: "Stängd",
  livechatProvidedInformation: "Tillhandahållen information",
  livechatNotAvailable: "Inte tillgänglig",
  livechatFeedback: "Feedback",
  livechatFeedbackSubmitted: "Skickad",
  livechatFeedbackSubmittedLine: "Skickad {datetime}",
  livechatNoFeedbackYet: "Ingen kundfeedback har skickats.",
  livechatWaitingForRating: "Väntar på kundbetyg.",
  livechatCustomerTypingBadge: "Kunden skriver",
  livechatAiContextBeforeJoined: "AI-kontext innan agenten anslöt",
  livechatLoadingOlderContext: "Laddar äldre kontext...",
  livechatLoadingAiContext: "Laddar AI-kontext...",
  livechatBeforeLivechatRequest: "Innan livechat-begäran",
  livechatAiSessionEnded: "AI-session avslutad",
  livechatWhileWaitingInQueue: "Medan i kö",
  livechatNoAiContext: "Ingen AI-kontext är tillgänglig.",
  livechatContextBeforeAgentJoined: "Kontext innan agenten anslöt",
  livechatLivechatTranscript: "Livechat-utskrift",
  livechatSelectLanguageOption: "Välj språk",
  livechatTranslateTranscriptLanguage: "Välj språk för översättning av livechat-utskrift",
  livechatTranslateTranscript: "Översätt",
  livechatTranslatingTranscript: "Översätter...",
  livechatFailedTranslateTranscript: "Det gick inte att översätta livechat-utskriften.",
  livechatTranslatedFrom: "Översatt från {language}",
  livechatShowOriginal: "Visa original",
  livechatShowTranslation: "Visa översättning",
  livechatLanguageNameCs: "Tjeckiska",
  livechatLanguageNameDa: "Danska",
  livechatLanguageNameDe: "Tyska",
  livechatLanguageNameEn: "Engelska",
  livechatLanguageNameEs: "Spanska",
  livechatLanguageNameFi: "Finska",
  livechatLanguageNameFr: "Franska",
  livechatLanguageNameIt: "Italienska",
  livechatLanguageNameNl: "Nederländska",
  livechatLanguageNameNo: "Norska",
  livechatLanguageNamePl: "Polska",
  livechatLanguageNameSv: "Svenska",
  livechatLoadingContext: "Laddar kontext...",
  livechatNoContextAvailable: "Ingen kontext är tillgänglig.",
  livechatLoadingOlderMessages: "Laddar äldre meddelanden...",
  livechatLoadingTranscript: "Laddar utskrift...",
  livechatNoMessagesYet: "Inga meddelanden har utväxlats ännu.",
  livechatCustomerIsTyping: "Kunden skriver...",
  livechatComposerReplyPlaceholder: "Svara kunden...",
  livechatComposerJoinToReply: "Gå med i sessionen för att börja svara.",
  livechatComposerTakeoverToReply: "Ta över sessionen för att börja svara.",
  livechatComposerProviderOwned: "Leverantören hanterar den här sessionen.",
  livechatComposerOtherAgent: "En annan agent hanterar den här sessionen.",
  livechatComposerSessionClosed: "Den här sessionen har stängts.",
  livechatComposerSaveProfile: "Spara din profil för att aktivera livechat-svar.",
  livechatAttachmentsSelected: "{count} bilaga vald",
  livechatAttachmentsSelectedPlural: "{count} bilagor valda",
  livechatSendReply: "Skicka svar",
  livechatSending: "Skickar...",
  livechatFailedSendMessage: "Det gick inte att skicka meddelandet.",
  livechatFailedReadFile: "Kunde inte läsa {filename}.",
  livechatAttachmentFallback: "Bilaga",
  livechatSaveProfileBeforeJoin:
    "Spara din livechat-profil innan du går med i eller svarar på sessioner för den här chatboten.",
  livechatSetProfile: "Ange profil",
  livechatAssignedToOtherAgent: "Den här sessionen är för närvarande tilldelad till ",
  livechatProviderOwnedNotice: "Leverantören hanterar den här sessionen",
  livechatAnotherAgent: "en annan agent",
  livechatProfileModalTitle: "Livechat-agentprofil",
  livechatProfileModalEyebrow: "{chatbotId} · {env}-miljö",
  livechatProfileLoading: "Laddar den aktiva profilen...",
  livechatProfileActivePrefix: "Aktiv profil:",
  livechatProfileNoneYet: "Ingen livechat-profil har sparats för {chatbotId} ännu.",
  livechatProfileNoChatbot: "Ingen chatbot",
  livechatDisplayName: "Visningsnamn",
  livechatAgentSpokenLanguages: "Språk du skriver på",
  livechatAgentSpokenLanguagesHelp:
    "Kundens chattwidget översätter bara dina meddelanden från dessa språk. Lämna tomt för att tillåta alla identifierade språk (korta svar kan feltolkas). Med flera valda språk väljer detekteringen bland dem.",
  livechatAvatarUrl: "Avatar-URL",
  livechatAvatarPlaceholder: "https://cdn.example.com/avatar.png",
  livechatAvatarUploadImage: "Ladda upp profilbild",
};
